import type { Study } from '@pocketprep/types'

type TAssignmentState = {
    assignments: Study.Class.PrebuiltQuizJSON[]
    assignment: Study.Class.PrebuiltQuizJSON | null
    assignmentQuestions: Study.Class.QuestionJSON[]
    completedAssignment: Study.Class.QuizJSON | null
}

export const getInitialAssignmentState = (): TAssignmentState => {
    return {
        assignments: [],
        assignment: null,
        assignmentQuestions: [],
        completedAssignment: null,
    }
}

const moduleState = getInitialAssignmentState()

export default moduleState
